export const SegmentType = {
    STATIC: 'static',
    AUTO_REFRESH: 'auto_refresh',
} as const;

export const SegmentTypeToLabel = {
    [SegmentType.STATIC]: 'Static',
    [SegmentType.AUTO_REFRESH]: 'Auto-refreshing',
};

// Shown in place of a name for a referenced segment the API no longer returns, or could not be looked up.
export const DELETED_SEGMENT_LABEL = 'Deleted segment';
export const UNAVAILABLE_SEGMENT_LABEL = 'Unavailable segment';

export type SegmentAudienceType = 'marketing' | 'transactional' | 'acquisition' | 're_acquisition';
export type SegmentRefreshType = (typeof SegmentType)[keyof typeof SegmentType];
export type SegmentSortField = 'id' | 'name';
